var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass: "link text-theme flex items-center space-x-1",
      on: {
        click: function ($event) {
          return _vm.$store.commit("openSiteFavourites")
        },
      },
    },
    [
      _c("span", { staticClass: "block w-5 h-5 flex-shrink-0" }, [
        _c(
          "svg",
          {
            staticClass: "w-full h-full",
            attrs: { viewBox: "0 0 20 18", fill: "none" },
          },
          [
            _c("path", {
              staticClass: "transition duration-300",
              attrs: {
                d: "M9.93864 16.9945C12.5943 14.3685 15.2783 11.8561 17.7882 9.1811C19.5651 7.28549 19.3212 4.28142 17.4927 2.46324C15.6371 0.620538 12.7053 0.504401 10.7013 2.19354C10.0225 2.76648 9.958 2.76648 9.29989 2.20903C7.25976 0.482464 4.24537 0.625699 2.41557 2.53808C0.589644 4.44401 0.496735 7.46228 2.33169 9.3695C4.8196 11.9542 7.39525 14.4537 9.93864 16.9945Z",
                stroke: "var(--theme)",
                fill: _vm.items.length ? `var(--theme)` : "none",
                "stroke-miterlimit": "10",
              },
            }),
          ]
        ),
      ]),
      _vm._v(" "),
      _vm.items.length
        ? _c("span", { staticClass: "font-bold" }, [
            _vm._v(_vm._s(_vm.items.length)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("span", { staticClass: "sr-only" }, [_vm._v("Favourites")]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }